import { useState } from "react";

function getPositionFromStore(store) {
  const position = localStorage.getItem(store);
  if (position) return JSON.parse(position);
}

function setPositionToStore(store, position) {
  localStorage.setItem(store, JSON.stringify(position));
}

export default function useDragEvent(store) {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState(getPositionFromStore(store));

  function onDrag() {
    if (isDragging) return;

    setIsDragging(true);
  }

  function onDragStop(_, data) {
    if (isDragging) {
      // if mouse up event after dragging
      const newPosition = { x: data.x, y: data.y };
      setPositionToStore(store, newPosition);
      setPosition(newPosition);

      setTimeout(() => {
        setIsDragging(false);
      }, 10);
    } else {
      setIsDragging(false);
    }
  }

  return { isDragging, position, onDrag, onDragStop };
}



// WEBPACK FOOTER //
// ./src/components/chatbot/useDragEvent.js